export const toMap = (data) => {
  if (!Array.isArray(data)) {
    return data;
  }

  return data.reduce((acc, room) => {
    acc.set(room.id, room);
    return acc;
  }, new Map());
};
